<div class="checkout-section">
  <form [formGroup]="scheduleForm" (ngSubmit)="onSubmit()">
    <div class="section-content">
      @if (!isScheduleDelivery) {
        <div>
          <div class="pickup-option selected">
            <input type="radio" formControlName="storePickupOption" value="in-store" />
            <div class="pickup-option-content">
              <div class="pickup-option-title">In Store Pickup</div>
              <div class="pickup-option-desc">
                Pick up your order at the store location
              </div>
              <div class="store-address">
                <div class="store-name">{{storeName}}</div>
                <div class="store-location">
                  {{storeDeliveryAddress?.formattedAddress}}
                </div>
                <div class="store-hours">Pick-up hours are Monday to Friday 8:00 A.M. - 4:00 P.M. [Time Zone of Plant/Facility]</div>
              </div>
            </div>
          </div>
          <div class="pickup-schedule">
            <div class="pickup-type-header">Schedule your pick up</div>
            <div class="pickup-type-options">
              <label class="pickup-type-option" [class.selected]="pickUpTypeControl.value === 'SCHEDULE'">
                <input type="radio" formControlName="pickUpType" value="SCHEDULE" id="pickupScheduled" />
                <div>Schedule Pickup</div>
              </label>
              <label class="pickup-type-option " [class.selected]="pickUpTypeControl.value === 'IMMEDIATE'">
                <input type="radio" formControlName="pickUpType" value="IMMEDIATE" id="pickupImmediate" />
                <div>Immediate Pickup</div>
              </label>
            </div>
          </div>
        </div>
      }
      @if (isScheduleDelivery) {
        <div class="pickup-type-header">
          Schedule your delivery
        </div>
      }
      <div class="calendar-section">
        @if (scheduleForm.get('pickUpType')?.value === 'SCHEDULE' && calendarReady) {
          <div>
            <mat-calendar #calendar [selected]="selected()" (selectedChange)="selectedDate($event)" [dateFilter]="disablePastDates">
            </mat-calendar>
          </div>
        }
        @if (scheduleForm.get('pickUpType')?.value === 'IMMEDIATE') {
          <div class="immediate-pickup-msg">Please Note: Orders placed at 4:00 PM EST or later on M-F or any time on a weekend/holiday with the “Immediate Pickup” option selected will be scheduled for pickup by 9:00 AM EST on the next available business day. Our regular business hours are Monday-Friday, 8:00 AM-5:00 PM EST, excluding company holidays.</div>
        }
        <div class="continue-container">
          <button type="submit" class="continue-btn" [disabled]="
              scheduleForm.get('pickUpType')?.value === 'SCHEDULE' &&
              !selected()
            ">
            Continue
          </button>
        </div>
      </div>

    </div>
  </form>
</div>